import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const floatUp = keyframes`
  from { transform: translateY(8px); opacity: 0; }
  to   { transform: translateY(0);   opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.15s ease;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level4};
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${floatUp} 0.18s ease;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurface};
  `}
`;

export const DropText = styled.p`
  text-align: center;
  margin: 0;
  animation: ${floatUp} 0.18s ease;

  ${({ theme: { colors, font } }) => css`
    font-size: ${font.headlineSmall.fontSize};
    line-height: ${font.headlineSmall.lineHeight};
    font-weight: 500;
    color: ${colors.onSurface};
  `}
`;

export const DropSubText = styled.p`
  text-align: center;
  margin: 0;
  animation: ${floatUp} 0.18s ease;

  ${({ theme: { colors, font } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;
